import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { LimitsPerNbSteps } from '@shared/constants';
import { SvgDirective } from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant3Config } from '@shared/models';
import {
  AmountPipe,
  ProgressWidthPipe,
  RewardPipe,
  SafePipe,
  StepStatusPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-progress-section',
  templateUrl: './progress-section.component.html',
  styleUrls: ['./progress-section.component.scss'],
  imports: [
    AmountPipe,
    SafePipe,
    RewardPipe,
    AmountPipe,
    SvgDirective,
    StepStatusPipe,
    ProgressWidthPipe,
    VariableReplacementPipe,
  ],
})
export class ProgressSectionComponent extends BaseComponent {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant3Config>();

  public limitsPerNbSteps: LimitsPerNbSteps = {
    oneStep: { start: 0, end: 180 },
    twoStep: { step1: { start: 0, end: 71 }, step2: { start: 86, end: 189 } },
    threeStep: {
      step1: { start: 0, end: 33 },
      step2: { start: 44, end: 109 },
      step3: { start: 117, end: 185 },
    },
  };
}
